import type { IExtendedTelemetryItem } from "@microsoft/1ds-analytics-js";
import type { CustomDataMap } from "owa-analytics-types";

export interface DiagnosticOverrides {
    IsRunningInAWorker: boolean;
    MsaDeviceTicketChanged?: boolean;
    Offline?: boolean;
    CommonPropertiesStatus?: "PENDING" | "SUCCESS" | "ERROR";
    CommonPropertiesError?: string;
    EventDuplicated?: true;
}

export function addCommonDiagnosticProperties(endpointUrl?: string, item?: IExtendedTelemetryItem, diagnosticOverrides?: DiagnosticOverrides, customDiagnosticsOptions?: CustomDataMap): void {
    if (item?.data) {
        let diagnostics = {};
        const originalDiagnostics = item.data["diagnostics"];
        
        if (originalDiagnostics) {
            // We can get strings that are not JSON, like callstacks
            try {
                diagnostics = JSON.parse(originalDiagnostics as string);
            }
            catch {
                diagnostics = {
                    originalDiagnostics,
                };
            }
        }
        
        item.data["diagnostics"] = JSON.stringify({
            ...diagnostics,
            ...diagnosticOverrides,
            ...customDiagnosticsOptions,
            EndpointUrl: endpointUrl || "none",
        });
    }
}
